import { useCallback } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ConnectedFilteredThreadAlert from 'conversations-thread-view/thread-details/components/ConnectedFilteredThreadAlert';
import ConnectedMessageAuthenticityAlert from 'conversations-thread-view/alerts/components/ConnectedMessageAuthenticityAlert';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ConnectedUnifiedThreadHistory from 'conversations-thread-view/unified-thread-history/components/ConnectedUnifiedThreadHistory';
import { isFilteredView, isUserGeneratedCustomView } from 'find-and-filter-data/views-schema/public';
import { useViewCanSeeDeletedMessages } from '../../thread-list/hooks/useViewCanSeeDeletedMessages';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ConnectedThreadWithDeletedMessagesBanner from 'conversations-thread-view/thread-deletion/components/ConnectedThreadWithDeletedMessagesBanner';
import { AsyncUIAvatar } from 'svh-workspace-ui-lib/code-splitting/public';
import InboxReplyComposer from './InboxReplyComposer';
import AsyncConnectedMessageComposerAlertTray from './AsyncConnectedMessageComposerAlertTray';
import { getUsageTracker } from '../../usage-tracking/clients/usageTracker';
import { ReplySubmitButtonGroup } from 'composer-ui/send-button/public/components';
import ConnectedAsyncFileManager from '../../file-manager/components/ConnectedAsyncFileManager';
import { ResizableThreadViewWrapper } from 'svh-workspace-ui-lib/resizable-thread-view/public/components';
import { launchAgentSurvey } from '../../custom-views/operators/customViewsCsatSurvey';
import { getIsConversationsAdmin } from '../../selectors/userSelectors/getIsConversationsAdmin';
import ToolbarContainer from '../../ticket-toolbar/components/ToolbarContainer';
import TicketWorkspaceDisagreementBanner from '../../ticket-workspace-disagreement/components/TicketWorkspaceDisagreementBanner';
import { useOnboardingSteps } from '../../new-feature-onboarding/hooks/useOnboardingSteps';
import { HAS_SENSITIVE_DATA_BANNER_STORAGE_KEY } from '../utils/hasSeenSensitiveDataBanner';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { SensitiveDataEditorBanner } from 'svh-workspace-ui-lib/banners/public/components';
import { useLocalStorage } from '../../local-storage/hooks/useLocalStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderExistingFileSelect = props => /*#__PURE__*/_jsx(ConnectedAsyncFileManager, Object.assign({}, props));
renderExistingFileSelect.displayName = 'renderExistingFileSelect';
const ThreadView = ({
  threadId,
  openZorseTaxonomyPanel,
  isKnownVisitor,
  view,
  ticket,
  ticketIsLoading,
  ticketError,
  inboxId
}) => {
  const showDeletedMessages = useViewCanSeeDeletedMessages();
  const {
    hasUserSeenOnboarding
  } = useOnboardingSteps();
  const isAdmin = useSelector(getIsConversationsAdmin);
  const canSeeSurvey = !isAdmin && isUserGeneratedCustomView(view);
  const renderSubmitButton = useCallback(props => {
    const handleOnClick = (e, options) => {
      if (canSeeSurvey) {
        // when we remove this feedback survey we can delete this entire
        // onClick handler & the onClick override prop
        launchAgentSurvey();
      }
      return props.onClick(e, options);
    };
    return /*#__PURE__*/_jsx(ReplySubmitButtonGroup, Object.assign({}, props, {
      associatedTicket: ticket,
      associatedTicketError: ticketError,
      associatedTicketIsLoading: ticketIsLoading,
      inboxId: inboxId,
      onClick: handleOnClick,
      openTaxonomyPanel: openZorseTaxonomyPanel
    }));
  }, [ticket, ticketError, ticketIsLoading, canSeeSurvey, inboxId, openZorseTaxonomyPanel]);
  const [hasSeenSensitiveDataBanner, setHasSeenSensitiveDataBanner] = useLocalStorage({
    key: HAS_SENSITIVE_DATA_BANNER_STORAGE_KEY,
    initialValue: 'false'
  });
  return /*#__PURE__*/_jsxs(ResizableThreadViewWrapper, {
    "data-test-id": "inbox-thread-loaded",
    children: [view && isFilteredView(view) ? /*#__PURE__*/_jsx(ConnectedFilteredThreadAlert, {
      threadId: threadId
    }) : /*#__PURE__*/_jsx(ConnectedMessageAuthenticityAlert, {
      threadId: threadId
    }), !showDeletedMessages ? /*#__PURE__*/_jsx(ConnectedThreadWithDeletedMessagesBanner, {
      threadId: threadId
    }) : null, /*#__PURE__*/_jsx(ToolbarContainer, {
      ticket: ticket,
      threadId: threadId,
      inboxId: inboxId
    }), /*#__PURE__*/_jsx(TicketWorkspaceDisagreementBanner, {
      ticket: ticket,
      threadId: threadId
    }), /*#__PURE__*/_jsx(ConnectedUnifiedThreadHistory, {
      associatedTicket: ticket,
      associatedTicketIsLoading: ticketIsLoading,
      AsyncUIAvatar: AsyncUIAvatar
      // TODO - test below - is this working?
      ,
      canRestoreMessagesForThread: !showDeletedMessages,
      threadId: threadId
    }), hasSeenSensitiveDataBanner !== 'true' && /*#__PURE__*/_jsx(SensitiveDataEditorBanner, {
      bannerText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-ui.alerts.sensitive-data"
      }),
      onClose: () => setHasSeenSensitiveDataBanner('true')
    }), /*#__PURE__*/_jsx(AsyncConnectedMessageComposerAlertTray, {
      threadId: threadId,
      hasUserSeenOnboarding: hasUserSeenOnboarding
    }), /*#__PURE__*/_jsx(InboxReplyComposer
    // @ts-expect-error the wrapper on this component doesn't properly pass forward the props
    , {
      isKnownVisitor: isKnownVisitor,
      renderExistingFileSelect: renderExistingFileSelect,
      renderSubmitButton: renderSubmitButton,
      threadId: threadId,
      tracker: getUsageTracker()
    })]
  });
};
ThreadView.displayName = 'ThreadView';
export default ThreadView;